import React, { ReactNode } from 'react';
import { Dispatch } from 'redux';
import { PageProps } from 'modules/Layout/type';
import { ManagePageAction, managePageAction } from 'modules/Layout/action';
import {
  manageThrow as manageThrowAction,
  ManageThrowAction
} from 'modules/Shared/action';
import { RootState } from 'app/reducer';
import { connect } from 'react-redux';
import { editUserFeedback, fetchUserFeedback } from 'modules/User/repository';
import { breadcrumbRouteFeedback } from 'modules/User/breadcrumbs';
import { FeedbackEntity } from '../../../model/Feedback';
import FeedbackDetails from '../../../component/Details/Feedback';

export interface StateProps {
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  manageThrow: (error: Error) => ManageThrowAction;
}

export interface Props extends StateProps, DispatchProps {
  id: string;
}

export interface State {
  feedback: FeedbackEntity;
}

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  manageThrow: (error: Error) => dispatch(manageThrowAction(error))
});

export const mapState = (state: RootState): StateProps => {
  const { type } = state.layout.page;

  return { type };
};

class UserFeedbackDetailsView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      feedback: null
    };

    this.onSetResponded = this.onSetResponded.bind(this);
  }

  async componentDidMount(): Promise<void> {
    const { managePage, id, manageThrow } = this.props;

    managePage({
      title: 'Feedback',
      breadcrumb: breadcrumbRouteFeedback(),
      type: 'loading'
    });

    try {
      const {
        data: { feedback }
      } = await fetchUserFeedback(id);

      this.setState({
        feedback
      });

      managePage({
        title: feedback.email,
        breadcrumb: breadcrumbRouteFeedback(feedback),
        type: null
      });
    } catch (error) {
      manageThrow(error);
    }
  }

  async onSetResponded(responded: boolean): Promise<void> {
    const { feedback } = this.state;

    try {
      await editUserFeedback(feedback.id, { responded });
      this.setState({
        feedback: {
          ...feedback,
          responded: Number(responded)
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  render(): ReactNode {
    const { type } = this.props;
    const { feedback } = this.state;

    if (type || !feedback) {
      return null;
    }

    return (
      <FeedbackDetails
        feedback={feedback}
        onSetResponded={this.onSetResponded}
      />
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(UserFeedbackDetailsView);
